export const HISTORY_LIMIT = 20;

export const initialHistory = (elements = []) => ({
    past: [],
    present: elements,
    future: [],
});

export const historyReducer = (state, action) => {
    switch (action.type) {
        case 'SET': {
            const next =
                typeof action.payload === 'function'
                    ? action.payload(state.present)
                    : action.payload;

            if (next === state.present) return state;

            return {
                past: [
                    ...state.past.slice(-(HISTORY_LIMIT - 1)),
                    state.present,
                ],
                present: next,
                future: [],
            };
        }
        case 'SET_SILENT': {
            const next =
                typeof action.payload === 'function'
                    ? action.payload(state.present)
                    : action.payload;

            if (next === state.present) return state;

            return {
                ...state,
                present: next,
                future: [],
            };
        }
        case 'UNDO': {
            if (state.past.length === 0) return state;

            const previous = state.past[state.past.length - 1];

            return {
                past: state.past.slice(0, -1),
                present: previous,
                future: [state.present, ...state.future].slice(0, HISTORY_LIMIT),
            };
        }
        case 'REDO': {
            if (state.future.length === 0) return state;

            const next = state.future[0];

            return {
                past: [
                    ...state.past.slice(-(HISTORY_LIMIT - 1)),
                    state.present,
                ],
                present: next,
                future: state.future.slice(1),
            };
        }
        case 'RESET': {
            return initialHistory(action.payload);
        }
        default:
            return state;
    }
};
